import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const productFieldsSchema: CollectionCreateSchema = {
  name: CollectionName.ProductFields,
  fields: [
    {
      name: "search_id",
      type: "string",
    },
    {
      name: "label",
      type: "string",
    },
  ],
  visibility: CollectionVisibility.EC,
}
